import { Injectable, NgZone } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Title } from '@angular/platform-browser';

import { environment } from '../../../environments/environment';

import { MenuI, LMenus, ImgI, CouleurI } from '../modeles/sets';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class MenusService {
  // menus: Array<MenuI> = [new LMenus()]; // Liste des ménus sélectionnés
  menus:{principal:Array<MenuI>, pied:Array<MenuI>} = {principal:[], pied:[]}; // Liste des ménus sélectionnés 
  menu: MenuI = new LMenus(); // Menu actuellement sélectionné
  page: Array<any> = [new Object()]; // Page actuelle
  contacts: Array<any> = [new Object()]; // Créer une liste de contacts vides
  couleurs: Array<CouleurI> = []; // Liste des couleurs disponibles
  pages: any;
  traductions: Array<any> = [new Object()];
  maintenance: boolean;
  rgpd: boolean; // Modifier la règle RGPD pour récupérer les statistiques

  langue: string; // Langue de l'utilisateur
  /**
   * Récupérer les menus au démarrage
   * @param http HttpClient
   */
  constructor(private http: HttpClient, private tServ: Title, private route: Router, private zone: NgZone) {
    this.checkProd(); // Vérifier si nous sommes en production ou non
    this.pages = new Object();
    this.getLangue() ? this.langue = this.getLangue() : this.langue = "fr";
    localStorage.getItem('rgpd') ? this.rgpd = eval(localStorage.getItem('rgpd')) : this.rgpd = true;
    this.getParams(); // Obtenir la liste des éléments du menu
  }
  /**
   * Check prod
   */
  checkProd() {
    this.http.get('assets/data/prod.json').subscribe(
      p => {
        this.maintenance = p['MAINTENANCE'];
      }
    );
  }
  /**
   * Récupérer les traductions des éléments du site (formulaire notamment)
   */
  getTraductions(): void {
    this.http.get<any>(environment.uri + '/mots.json').subscribe(t => {
      console.log(t);
      this.traductions = t;
    });
  }
  /**
   * Retourner la traduction du mot sélectionné
   */
  getTraduction(alias: string) {
    for (let a of this.traductions) {
      if (a.alias == alias) {
        return a[this.langue];
      }
    };
  }
  /**
   * Obtenir la langue locale de l'utilsateur
   */
  getLangue(): string {
    return localStorage.getItem("langue");
  }
  /**
   * Paramètrer la langue locale de l'utilisateur
   * @param l Langue à sauvegarder localement
   */
  setLangue(l) {
    localStorage.setItem("langue", l);
    this.langue = l;
    this.getPages();
  }
  /**
   * Récupérer les liens et paramètres des menus
   */
  // getMenus(alias: string = null) {
  //   this.http.get<any>(environment.uri + '/params.json').subscribe(params => {
  //     if (this.menus.length <= 1) {
  //       this.menus = params.m.sort((a, b) => (a.ordre > b.ordre) ? 1 : ((b.ordre > a.ordre) ? -1 : 0));
  //       this.getMenu(this.route.url.substr(1, this.route.url.length));
  //     };
  //   });
  // }
  /** Récupérer les données partagées entre les langues */
  getParams() {
    this.http.get<any>(environment.uri + '/params.json').subscribe(params => {
      this.contacts = params.contacts;
      this.couleurs = params.couleurs;
      // this.menus = params.sitemaps.sort((a, b) => (a.ordre > b.ordre) ? 1 : ((b.ordre > a.ordre) ? -1 : 0)) || [];
      this.menus = this.setMenus(params.sitemaps.sort((a, b) => (a.ordre > b.ordre) ? 1 : ((b.ordre > a.ordre) ? -1 : 0)));
      this.getMenu(this.route.url.substr(1, this.route.url.length));
      this.getPages();
    });
  }
  /** Récupérer les pages traduites */
  getPages() {
    if (this.langue) {
      this.http.get<any>(environment.uri + '/' + this.langue + '.json').subscribe(pages => {
        this.pages = pages;
        this.getPage(this.menu.chemin); // Afficher la page en cours
        this.getTraductions();
      });
    }
  }
  /** Filtrer les menus */
  setMenus(m:Array<any>){
    let menus:any = {};
    m.forEach(menu=>{
      if(menu.menu && !menus.hasOwnProperty(menu.menu)){
        menus[menu.menu] = [];
      }
      menus[menu.menu].push(menu);
    });
    console.log("Menus filtrés", menus);
    return menus;
  }
  /**
   * Récupérer le menu cliqué en fonction de son alias
   * @param { string } alias Alias du menu servant à faire le tri
   */
  getMenu(alias: string, menu:Array<MenuI>=this.menus.principal) {
    if (alias.length == 0) { alias = 'vincis' };
    // Lister le menu principal
    for (let m of menu) {
      if (alias == m.chemin) {
        this.menu = m;
        break;
      }
    }
    /**
     * Changer le titre de la page HTML
     */
    if (this.menu['titre_' + this.langue]) {
      this.tServ.setTitle("VInCI / " + this.menu['titre_' + this.langue]);
    }
    console.log("Menu sélectionné :", this.menu);
  }
  /**
   * Récupérer les pages du site
   * @param { string } alias Alias du menu servant à faire le tri
   */
  getPage(alias: string) {
    // if (!this.pages.hasOwnProperty(alias)) {
    //   await this.http.get<Array<any>>(environment.uri + '/' + alias).subscribe(p => {
    //     this.pages[this.menu.chemin] = p;
    //     console.log(this.menu, p, this.pages);
    //     document.getElementById("loader").classList.add('cache');
    //   });
    // }
    console.log(alias, this.menu.chemin, this.pages);
    this.page = this.pages[alias];
    document.getElementById("loader").classList.add('cache');
    console.log(this.page);
  }
  /**
   * Ajouter l'URL aux média pour leur chargement
   * @param m Un média ou une liste de médias
   */
  setMedias(m: any) {
    if (typeof m === "object") {
      m.url = environment.uri + m.url;
    } else if (Array.isArray(m)) {
      m.forEach(i => {
        i.url = environment.uri + i.url;
      })
    }
  }
  /**
   * Définir le choix RGPD
   */
  setRgpd() {
    this.rgpd = !this.rgpd;
    localStorage.setItem('rgpd', String(this.rgpd));
  }
  /**
   * Envoyer un email depuis le formulaire de contact
   * @param f Données du formulaire pour l'envoie d'emails
   */
  envoieMail(f: any) {
    return this.http.post(environment.uri + '/email', f);
  }
}
